import React, { useState } from 'react';
import { Modal } from 'bootstrap';
import clientHttp from '../../components/ClientHttp';
import { useNavigate } from "react-router-dom";

export default function BankAccountList({ data, searchSubmit, currentPage }) {
    const DOWNLOADSTATUS_LIST = ["None", "Bill Payment", "Balance Transfer", "History Statement", "E-Banking", "Gateway"]

    // for edit bank account info
    const [selectedBank, setSelectedBank] = useState(null)
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [corpid, setCorpid] = useState('')
    const [alias, setAlias] = useState('')
    const [status, setStatus] = useState('1')
    const [editMessage, setEditMessage] = useState('')
    const [editMessageClass, setEditMessageClass] = useState('');
    const [isSaving, setIsSaving] = useState(false)
    const [isSaveCompleted, setIsSaveCompleted] = useState(false)
    const handleStatusChange = (event) => { 
        setStatus(event.target.value);
        console.log(event.target.value); 
    };

    let navigate = useNavigate()

    async function editBankAccount(item) {
        console.log('[editBankAccount] bank account: ', item.bankabv, item.bankno, item.transtype)
        setSelectedBank(item)
        // set value
        setUsername(item.username)
        setPassword(item.password)
        setCorpid(item.corpid)
        setAlias(item.alias)
        setStatus(item.status.toString())
        setIsSaveCompleted(false)
        // message
        setEditMessage('')
        setEditMessageClass('text-danger')

        let bankAccountForm = new Modal('#bankAccountForm')
        bankAccountForm.show()
    }

    async function saveBankAccount() {
        setIsSaving(true)
        setIsSaveCompleted(false)

        const formData = {
            bankAbv: selectedBank.bankabv,
            bankNo: selectedBank.bankno,
            transType: selectedBank.transtype,
            username: username,
            password: password,
            corpid: corpid,
            alias: alias,
            status: status,
            user: localStorage.getItem('name')
        }
        console.log('call update bank account api with parameters: ')
        console.log(formData)

        // call mark order api
        let token = localStorage.getItem('token')
        await clientHttp.post('setting/v1/bankaccount_update', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            console.log(response)
            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('update bank account success')

                setEditMessageClass('text-success')
                setEditMessage(response.data.message)
            } else {
                console.log('update bank account failed: ' + response.data.message)
                setEditMessage(response.data.message)
            }
        }).catch(err => {
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('update bank account failed: ' + err.message)
                setEditMessage(err.message)
            }
        })

        setIsSaveCompleted(true)
        setIsSaving(false)
    }

    return (
        <>
            <div id="bankAccountList" className="table-responsive table-hover table-sales text-nowrap">
                <table id="basic-datatables" className="table table-striped table-hover align-items-center mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">Bank</th>
                            <th scope="col">Bank No</th>
                            <th scope="col">Type</th>
                            <th scope="col">Username</th>
                            <th scope="col">Password</th>
                            <th scope="col">CorpID</th>
                            <th scope="col">Alias</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.map((item, index) => {
                                let status = parseInt(item.status) === 1 ? 'Active' : 'Inactive'
                                let statusClass = parseInt(item.status) === 1 ? 'text-success' : 'text-secondary'
                                return (
                                    <tr key={index}>
                                        <td>{item.bankabv}</td>
                                        <td>{item.bankno}</td>
                                        <td>{DOWNLOADSTATUS_LIST[item.transtype]}</td>
                                        <td>{item.username}</td>
                                        <td>{item.password}</td>
                                        <td>{item.corpid}</td>
                                        <td>{item.alias}</td>
                                        <td className={statusClass}>{status}</td>
                                        <td><button type="button" className="btn btn-link text-primary" onClick={editBankAccount.bind(this, item)}><i className="bi bi-pencil me-2" title="Edit"></i></button></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>

            <div className="modal fade" id="bankAccountForm" tabIndex="-1" aria-labelledby="bankAccountLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Bank Account</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Bank :</label>
                                    <div className="col-sm-9 mt-2">{selectedBank?.bankabv}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Bank No :</label>
                                    <div className="col-sm-9 mt-2">{selectedBank?.bankno}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Type :</label>
                                    <div className="col-sm-9 mt-2">{DOWNLOADSTATUS_LIST[selectedBank?.transtype]}</div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Username :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={username} onChange={e => setUsername(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Password :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={password} onChange={e => setPassword(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">CorpID :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={corpid} onChange={e => setCorpid(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-2 row">
                                    <label className="col-sm-3 col-form-label">Alias :</label>
                                    <div className="col-sm-9">
                                        <input type="text" className="form-control" value={alias} onChange={e => setAlias(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-2 mt-2 row">
                                    <label className="col-sm-3 col-form-label">Status :</label>
                                    <div className="col-sm-9">
                                        <div className="input-group">
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="status" value="1" checked={status === '1'} onChange={handleStatusChange} /> Active
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="status" value="2" checked={status === '2'} onChange={handleStatusChange} /> Inactive
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="mb-3">
                                <p className="mt-4 mb-6">
                                    <span className={editMessageClass}>{editMessage}</span>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dark" data-bs-dismiss="modal" onClick={searchSubmit.bind(this, currentPage)}>Close</button>
                            {isSaving ?
                                <button className="btn btn-primary" style={{ width: '120px' }} type="button">
                                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span className="ms-3">Save</span>
                                </button>
                                : !isSaveCompleted &&
                                <button type="button" className="btn btn-primary" style={{ width: '120px' }} onClick={saveBankAccount.bind(this)}>
                                    <i className="bi bi-floppy"></i> Save
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}